import Button, { ButtonVariants } from '~/components/atoms/Button/Button'

import styles from './FallbackPagination.module.css'

export interface FallbackPaginationProps {
  testID?: string
  total: number
  limit?: number
  queryParams: {
    slug: string
    nextPage: number | string
  }
  route?: string
}

export default function FallbackPagination({
  testID,
  total,
  queryParams,
  limit = 96,
  route,
}: FallbackPaginationProps) {
  const paginationAmount = Math.ceil(total / limit)

  const renderPagination = () => {
    const links = []
    for (let index = 1; index <= paginationAmount; index++) {
      if (+queryParams.nextPage - 1 === index) {
        links.push(
          <li key={`pagination-item-${index}`}>
            <span aria-label={`page ${index}`} aria-current="page">
              {index}
            </span>
          </li>
        )
      } else {
        const link = index > 1 ? `/page/${index}` : ''
        links.push(
          <li key={`pagination-item-next-${index}`}>
            <Button
              link={`/${route ? `${route}-` : ''}${queryParams.slug}${link}`}
              variant={ButtonVariants.textLink}
            >
              <span className="visualHidden">Page</span> {index}
            </Button>
          </li>
        )
      }
    }

    return (
      <nav aria-label="pagination" className="nojsPagination">
        <ul>{links}</ul>
      </nav>
    )
  }
  return (
    <div className={styles.base} data-testid={testID}>
      {renderPagination()}
    </div>
  )
}
